// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__3gebs","header":"Card_header__NzLmn","section":"Card_section__3oWUA","footer":"Card_footer__11KGc"};